import { BasePagedSearchCriteria } from './BaseSearchCriteria';

export interface LocalitySearchCriteria extends BasePagedSearchCriteria {
  cityName?: string;
  organizationId?: number;
}

export const LOCALITY_SEARCH_CRITERIA_KEY = 'LocalitySearchCriteria';
